// extracted by mini-css-extract-plugin
export default {"button":"Button_button__+BKgh","hollow":"Button_hollow__sOFNx","dark":"Button_dark__5QyeA","yellow":"Button_yellow__Paeg4","red":"Button_red__bqP50"};